import type {
  HeaderLayoutContent,
  HeaderLayoutProps,
} from "scmp-app/components/header/layouts/types";
import {
  AbsoluteCenterFeatureContainer,
  ArticleHamburgerMenuLogoWrapper,
  ArticleIconsWrapper,
  ArticleSearchSectionWrapper,
  ArticleSectionAllTabWrapper,
  CenterFeatureContainer,
} from "scmp-app/components/header/styles";

export const getArticleLayout = ({
  features,
  shouldSwap,
}: HeaderLayoutProps): HeaderLayoutContent => ({
  center: (
    <>
      <CenterFeatureContainer>
        {features.section({
          shouldSwap,
          showIn: "desktopUp",
          showOnSwap: true,
          size: "small",
          variant: "center",
        })}
        {features.articleHeadline({
          display: "block",
          shouldSwap,
          showIn: "desktopUp",
          showOnSwap: true,
        })}
      </CenterFeatureContainer>
      <AbsoluteCenterFeatureContainer>
        {features.logoTextLink({
          hideOnSwap: true,
          shouldSwap,
          showIn: "mobileUp",
        })}
      </AbsoluteCenterFeatureContainer>
    </>
  ),
  left: (
    <>
      <ArticleHamburgerMenuLogoWrapper $shouldSwap={shouldSwap}>
        {features.hamburgerMenu({ showIn: "mobileAndTablet" })}
        {features.logoLink({
          shouldSwap,
          showIn: "mobileOnly",
          showOnSwap: true,
        })}
        {features.logoTextLink({
          shouldSwap,
          showIn: "tabletUp",
          showOnSwap: true,
          size: "small",
        })}
      </ArticleHamburgerMenuLogoWrapper>
      <ArticleSearchSectionWrapper>
        {features.search({ hideOnSwap: true, shouldSwap, showIn: "mobileUp" })}
        <ArticleSectionAllTabWrapper>
          {features.section({
            hideOnSwap: true,
            shouldSwap,
            showIn: "desktopUp",
            size: "large",
          })}
          {features.oneLineMenu({
            hideOnSwap: true,
            isShowFullList: false,
            shouldSwap,
            showIn: "desktopUp",
          })}
        </ArticleSectionAllTabWrapper>
      </ArticleSearchSectionWrapper>
    </>
  ),
  right: (
    <>
      {features.subscription({
        fallback: features.myNews({
          hideOnSwap: true,
          shouldSwap,
          showIn: "mobileUp",
        }),
        shouldSwap,
        showIn: "mobileUp",
        showOnSwap: "mobile",
      })}
      <ArticleIconsWrapper>
        {features.share({ shouldSwap, showIn: "mobileUp", showOnSwap: true })}
        {features.bookmark({ shouldSwap, showIn: "mobileUp", showOnSwap: true })}
        {features.comment({ shouldSwap, showIn: "mobileUp", showOnSwap: true })}
        {features.dashboard({
          hideOnSwap: true,
          shouldSwap,
          showIn: "mobileUp",
        })}
      </ArticleIconsWrapper>
    </>
  ),
});
